import { NgClass } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { ToastService } from '../../services/toast/toast.service';

@Component({
  selector: 'dc-toast',
  standalone: true,
  imports: [NgClass],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent {
  readonly toast = inject(ToastService);

  toastClass = computed(() => {
    switch (this.toast.type()) {
      case 'success':
        return 'toast-success';
      case 'error':
        return 'toast-error';
      case 'info':
        return 'toast-info';
      default:
        return 'toast-error';
    }
  });
}
